import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Checklist pre-aplicación',
    desc: 'lista para usar con cada paciente'
  }, {
    title: 'Guía rápida de selección de tensión',
    desc: 'por objetivo clínico'
  }, {
    title: 'Ficha de registro mínima',
    desc: 'de Kinesiotaping para tu documentación'
  }, {
    title: 'FAQ completo',
    desc: 'con las preguntas más frecuentes de pacientes y profesionales'
  }, {
    title: 'Glosario de términos clave',
    desc: 'para dominar el lenguaje clínico'
  }, {
    title: 'Referencias científicas actualizadas',
    desc: 'para respaldar tu práctica'
  }];
  return <section className="py-16 px-4 bg-navy-900" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <FadeIn data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-cream-100 mb-10" data-id="element-36">
            Además Incluye:
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-37">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-38">
              <div className="flex items-start bg-navy-800 p-6 rounded-sm border border-navy-700 hover:border-gold-500/30 transition-colors h-full" data-id="element-39">
                <CheckCircle2 className="w-6 h-6 text-gold-500 mr-4 flex-shrink-0 mt-1" data-id="element-40" />
                <div data-id="element-41">
                  <strong className="text-cream-100 block text-lg mb-1" data-id="element-42">
                    {bonus.title}
                  </strong>
                  <span className="text-cream-200/80" data-id="element-43">{bonus.desc}</span>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}